import { createSlice } from "@reduxjs/toolkit";
import { Stripe } from "@stripe/stripe-js";
import { ERROR_CODES } from "@/lib/error-messages";
import { initiateCheckout, setPaymentMethod } from "../thunks/payment.thunks";

interface PaymentState {
  setupIntent: {
    clientSecret: string | null;
    customerId: string | null;
    setupIntentId: string | null;
    loading: boolean;
    error: string | null;
  };
  defaultPayment: {
    loading: boolean;
    error: string | null;
  };
  stripe: {
    instance: Stripe | null;
    error: string | null;
  };
}

const initialState: PaymentState = {
  setupIntent: {
    clientSecret: null,
    customerId: null,
    setupIntentId: null,
    loading: false,
    error: null,
  },
  defaultPayment: {
    loading: false,
    error: null,
  },
  stripe: {
    instance: null,
    error: null,
  },
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    resetPaymentState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(initiateCheckout.pending, (state) => {
        state.setupIntent.loading = true;
        state.setupIntent.error = null;
      })
      .addCase(initiateCheckout.fulfilled, (state, action) => {
        state.setupIntent.loading = false;
        state.setupIntent.clientSecret = action.payload.clientSecret;
        state.setupIntent.customerId = action.payload.customerId;
        state.setupIntent.setupIntentId = action.payload.setupIntentId;
      })
      .addCase(initiateCheckout.rejected, (state) => {
        state.setupIntent.loading = false;
        state.setupIntent.error = ERROR_CODES.FAILED_TO_CREATE_SETUP_INTENT;
      })
      .addCase(setPaymentMethod.pending, (state) => {
        state.defaultPayment.loading = true;
        state.defaultPayment.error = null;
      })
      .addCase(setPaymentMethod.fulfilled, (state) => {
        state.defaultPayment.loading = false;
      })
      .addCase(setPaymentMethod.rejected, (state) => {
        state.defaultPayment.loading = false;
        state.defaultPayment.error = ERROR_CODES.FAILED_TO_SET_PAYMENT_METHOD;
      });
  },
});

export const { resetPaymentState } = paymentSlice.actions;
export default paymentSlice.reducer;
